/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
// import Button from '../../../atoms/Button';
import { Field } from './style';

const FieldCheckbox = ({ checked, children, ...props }) => (
    <>
      <Field size="large" color="secondary" variant={checked ? 'contained' : 'outlined'} {...props}>
        {children}
      </Field>
    </>
  );

FieldCheckbox.propTypes = {
  checked: PropTypes.bool,
};

FieldCheckbox.defaultProps = {
  checked: false,
};
export default FieldCheckbox;
